<script>
    import MBaseFormElement from "@/assets/plugins/mps-form/providers/MBaseFormElement";
    import {isNOU} from "@/assets/plugins/mps-common/expansions/condition";

    export default {
        name: "MBaseFormTextarea",
        extends: MBaseFormElement,
    }
</script>